import { render } from "./PaymentHistoryDetails.vue?vue&type=template&id=47474d2d"
import script from "./PaymentHistoryDetails.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PaymentHistoryDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47474d2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47474d2d', __exports__)) {
    api.reload('47474d2d', __exports__)
  }
  
  module.hot.accept("./PaymentHistoryDetails.vue?vue&type=template&id=47474d2d", () => {
    api.rerender('47474d2d', render)
  })

}


export default __exports__